<template>
  <div class="home-box">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">
          Contribution for District Signature Project | Month: {{ month }}
        </h3>
        <v-spacer></v-spacer>
        <go-back-btn></go-back-btn>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form class="pa-5" v-if="contribution && !loading">
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Contribution</div>
            <div class="caption">{{ contribution.contribution }}</div>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-row v-if="contribution.documents">
          <v-col
            cols="3"
            v-for="item in contribution.documents"
            :key="item.uuid"
          >
            <v-card v-if="item.type === 'pdf'" @click="openImage(item.path)">
              <v-chip class="ma-2" color="pink" label text-color="white">
                <v-icon left>
                  mdi-file-pdf-box
                </v-icon>
                PDF document
              </v-chip>
            </v-card>
            <v-card v-else @click="openImage(item.path)">
              <v-img
                :src="item.path"
                height="150"
                class="grey darken-4"
              ></v-img>
              <v-divider></v-divider>
              <v-card-actions class="text-h6 pa-2">
                Photo
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import GoBackBtn from "@/components/shared/GoBackBtn";
import Alert from "@/components/shared/Alert";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "ContributionDistrictSignatureProjectView",

  components: { GoBackBtn, Alert },

  data: () => ({
    month: "",
    loading: false,
    errors: null,
    contribution: [],
  }),

  mounted() {
    this.month = this.$route.params.month;
    this.getContribution();
  },

  methods: {
    getContribution() {
      if (this.$route.params.aId !== null) {
        this.loading = true;
        ActivityService.getActivityCommonInfo(
          this.$route.params.key,
          this.$route.params.aId
        )
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.contribution = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.contribution = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
    onDismissed() {
      this.errors = null;
    },
    openImage(path) {
      window.open(path, "_blank");
    },
  },
};
</script>
